// Search popdown fix: capturing-phase listener fires before native <details> toggle
// and before theme.js's bubbling listener, giving us full control of open/close state.
(function () {
  function closeAllSearch() {
    document.querySelectorAll('search-popdown[data-popdown-in-header] details').forEach(function (det) {
      det.classList.remove('is-open');
      det.removeAttribute('open');
    });
    document.body.classList.remove('search-opened');
  }

  document.addEventListener('click', function (e) {
    var insidePopdown = e.target.closest('search-popdown[data-popdown-in-header]');

    // Close when clicking the X button inside the popdown
    if (insidePopdown && e.target.closest('[data-popdown-close]')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      closeAllSearch();
      return;
    }

    // Close when clicking outside any open search
    if (!insidePopdown) {
      if (document.querySelector('search-popdown[data-popdown-in-header] details.is-open')) {
        closeAllSearch();
      }
      return;
    }

    // Handle the toggle button click
    var toggle = e.target.closest('[data-popdown-toggle]');
    if (!toggle) return;

    e.stopImmediatePropagation(); // prevent native <details> toggle and theme.js listener
    e.preventDefault();

    var details = toggle.closest('details');
    if (!details) return;

    if (details.classList.contains('is-open')) {
      closeAllSearch();
    } else {
      closeAllSearch();
      details.setAttribute('open', '');
      details.classList.add('is-open');
      document.body.classList.add('search-opened');
      var input = details.querySelector('.search-form__input');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  }, true); // true = capturing phase
})();

// Quickview slider: .pdp-slider-btn buttons exist in DOM but have no listeners
// in AJAX-injected context (product.liquid's setup() only runs on full page load).
// Event delegation here handles prev/next for scroll-snap slider in quickview.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.pdp-slider-btn');
  if (!btn) return;

  var wrap = btn.closest('.pdp-slider-wrap');
  if (!wrap) return;

  var slider = wrap.querySelector('[data-product-single-media-slider]');
  if (!slider) return;

  var isPrev = btn.classList.contains('pdp-slider-prev');

  // Try Flickity API first (in case Flickity is active and not overridden)
  if (window.Flickity) {
    var flkty = Flickity.data(slider);
    if (flkty) {
      isPrev ? flkty.previous() : flkty.next();
      return;
    }
  }

  // Fallback: scroll-snap native scroll (CSS in product.liquid forces this layout)
  slider.scrollBy({ left: isPrev ? -slider.offsetWidth : slider.offsetWidth, behavior: 'smooth' });
});

function updateCartCounter(cart) {
  const counterEls = document.querySelectorAll('span.cart-counter');
  counterEls.forEach(el => {
    el.textContent = cart.item_count;
  });
}

function fetchAndUpdateCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateCartCounter(cart))
    .catch(error => console.error('Error fetching cart:', error));
}

// Listen for any known cart update events
document.addEventListener('cart:updated', () => {
  fetchAndUpdateCart();
});

// Optionally listen for add-to-cart buttons
document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener('submit', () => {
    setTimeout(fetchAndUpdateCart, 500); // wait for Shopify AJAX
  });
});

// Fallback polling every 30s instead of 1s
setInterval(fetchAndUpdateCart, 10000); // Poll only as fallback
